export const Checked = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.469727" width="21.5" height="21.5" rx="6" fill="#5D5FEF" />
    <path
      d="M9.60603 14.6758C9.40553 14.6758 9.21505 14.5956 9.0747 14.4552L6.23758 11.6181C5.94685 11.3274 5.94685 10.8462 6.23758 10.5554C6.52831 10.2647 7.00951 10.2647 7.30024 10.5554L9.60603 12.8612L14.759 7.70828C15.0497 7.41755 15.5309 7.41755 15.8216 7.70828C16.1124 7.99901 16.1124 8.48022 15.8216 8.77095L10.1374 14.4552C9.99701 14.5956 9.80653 14.6758 9.60603 14.6758Z"
      fill="white"
    />
  </svg>
);
